import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Panel, fmtDate } from "@/components/Peep";
import { NotificationSettings } from "@/components/NotificationSettings";

export default function CreatorNotifications() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/notifications").then((r) => setD(r.data)).catch(() => setD({ items: [], unread: 0 }));
  }, []);
  const readAll = async () => {
    await api.post("/notifications/read-all").catch(() => {});
    setD((x) => ({ ...x, unread: 0, items: x.items.map((i) => ({ ...i, read: true })) }));
  };
  return (
    <div data-testid="creator-notifications" className="flex flex-col gap-6">
      <h1 className="text-3xl font-extrabold">Notifications</h1>
      <Panel title="Recent" action={d?.unread ? <button onClick={readAll} data-testid="notif-read-all" className="text-xs text-[#f0a8fa]">Mark all read</button> : null}>
        {!d ? <p className="text-sm text-[#a7a0af]">Loading…</p> : d.items.length === 0 ? (
          <p data-testid="notif-empty" className="text-sm text-[#a7a0af]">No notifications yet. New followers, members and tips will appear here.</p>
        ) : (
          <ul data-testid="notif-list" className="flex flex-col">
            {d.items.map((n) => (
              <li key={n.id || n.created_at} className="border-t border-white/5 first:border-0">
                <button onClick={() => n.url && navigate(n.url)} className="flex w-full items-start justify-between gap-3 py-2.5 text-left">
                  <span className="min-w-0">
                    <span className={`block text-sm ${n.read ? "text-[#c7c1cf]" : "font-semibold text-white"}`}>{n.title}</span>
                    {n.body && <span className="block truncate text-xs text-[#a7a0af]">{n.body}</span>}
                  </span>
                  <span className="shrink-0 text-[0.65rem] text-[#6f6878]">{fmtDate(n.created_at)}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Panel>
      <NotificationSettings audience="creator" />
    </div>
  );
}
